import { FunctionComponent, Fragment } from 'react'
import Navbar from '@/components/Navbar'
import loadingStyle from '@/components/LoadingPage/loading-style'

const LoadingPage: FunctionComponent<{
  withoutNav?: boolean
  text?: string
}> = ({ withoutNav, text }) => {
  const { loading, auxiliaryText, loadingContainer } = loadingStyle()
  return (
    <Fragment>
      {!withoutNav ? <Navbar /> : null}
      <div css={loadingContainer} className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-center flex-column align-items-center">
              <div css={loading} />
              <h4 css={auxiliaryText}>{text}</h4>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default LoadingPage
